import React from "react";
// import Home from "../pages/home";
import Page from "@jumbo/shared/Page";
import NotFound from "app/pages/404";
import { inventoryRoute } from "./Inventory";
import { purchaseOrderRoute } from "./PurchaseOrder";
import Error404 from "app/pages/404";
import { salesOrderRoute } from "./ConfirmSalesOrder";
import { paymentRoute } from "./Payment";
import Login from "app/pages/Login/Index";
import { faqRoute } from "./Faq";
import { myBranchRoute } from "./MyBranch";

/**
 routes which you want to make accessible to both authenticated and anonymous users
 **/
const routesForPublic = [
  {
    path: "/",
    element: <Page component={Login} layout={"solo-page"} />,
  },
  {
    path: "/login",
    element: <Page component={Login} layout={"solo-page"} />,
  },
  {
    path: "*",
    element: (
      <Page component={Error404} layout={"solo-page"} disableSmLogin={true} />
    ),
  },
  {
    path: "/",
    // element: <Page component={NotFound} />
  },
];

/**
 routes only accessible to authenticated users
 **/
const routesForAuthenticatedOnly = [
  ...myBranchRoute,
  ...inventoryRoute,
  ...purchaseOrderRoute,
  ...salesOrderRoute,
  ...paymentRoute,
  ...faqRoute
];

/**
 routes only accessible when user is anonymous
 **/
const routesForNotAuthenticatedOnly = [];

const routes = [
  ...routesForPublic,
  ...routesForAuthenticatedOnly,
  ...routesForNotAuthenticatedOnly,
];

export {
  routes as default,
  routesForPublic,
  routesForNotAuthenticatedOnly,
  routesForAuthenticatedOnly,
};
